module.exports = __webpack_public_path__ + "img/tou0.ebaaa621.jpg";